import { render, staticRenderFns } from "./InformationSharedCard.vue?vue&type=template&id=2af4da1c&"
import script from "./InformationSharedCard.vue?vue&type=script&lang=ts&"
export * from "./InformationSharedCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports